import { useSearchParams } from 'react-router-dom';

type DetailTypes = `supervisor`;
export type DetailTabTypes = `stop_fields` | `stop_completed_fields` | `stop_canceled_fields` | `survey_fields`;

type SetSupervisorRightPanelInfoProps = {
  detailId?: string | null;
  detailType?: DetailTypes | null;
  detailTab?: DetailTabTypes | null;
};

type UseRetrieveSupervisorRightPanelInfoResponse = {
  detailId?: string;
  detailType?: DetailTypes;
  detailTab?: DetailTabTypes;
  setRightPanelInfo: (rightPanelProps: SetSupervisorRightPanelInfoProps) => void;
  cleanRightPanelInfo: () => void;
};

export const useRetrieveSupervisorRightPanelInfo = (): UseRetrieveSupervisorRightPanelInfoResponse => {
  const [searchParams, setSearchParams] = useSearchParams();

  // TODO: TRY MEMOIZED???

  const detailIdParam = searchParams.get(`detailId`);
  const detailId = detailIdParam !== null ? detailIdParam : undefined;

  const detailTypeParam = searchParams.get(`detailType`);
  const detailType = detailTypeParam !== null ? (detailTypeParam as DetailTypes) : undefined;

  const detailTabParam = searchParams.get(`detailTab`);
  const detailTab = detailTabParam !== null ? (detailTabParam as DetailTabTypes) : undefined;

  const setRightPanelInfo = ({ detailId, detailType, detailTab }: SetSupervisorRightPanelInfoProps) => {
    if (detailId !== undefined) {
      if (detailId !== null) {
        searchParams.set(`detailId`, `${detailId}`);
      } else {
        searchParams.delete(`detailId`);
      }
    }

    if (detailType !== undefined) {
      if (detailType !== null) {
        searchParams.set(`detailType`, `${detailType}`);
      } else {
        searchParams.delete(`detailType`);
      }
    }

    const storedDetailTab = localStorage.getItem(`${searchParams.get(`detailType`)}_DETAIL_TAB`);
    if (detailTab !== undefined) {
      if (detailTab !== null) {
        searchParams.set(`detailTab`, `${detailTab}`);
        localStorage.setItem(`${searchParams.get(`detailType`)}_DETAIL_TAB`, `${detailTab}`);
      } else if (storedDetailTab) {
        searchParams.set(`detailTab`, `${storedDetailTab}`);
      } else {
        searchParams.delete(`detailTab`);
      }
    }
    setSearchParams(searchParams);
  };

  const cleanRightPanelInfo = () => {
    setRightPanelInfo({
      detailId: null,
      detailType: null,
      detailTab: null,
    });
  };

  return {
    detailId,
    detailType,
    detailTab,
    setRightPanelInfo: setRightPanelInfo,
    cleanRightPanelInfo: cleanRightPanelInfo,
  };
};
